import { Mail, Instagram, Copy, Check } from "lucide-react";
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { toast } from "sonner";

const SUPPORT_EMAIL = "byochakhape@gmail.com";

export default function ContactDialog({ open, onOpenChange }) {
  const [copied, setCopied] = useState(false);

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(SUPPORT_EMAIL);
      setCopied(true);
      toast.success("Email copied to clipboard");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Could not copy — please copy the email manually");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="contact-dialog"
        className="bg-[#0A0A0A] border border-[#27272A] text-[#F3F3F2] max-w-lg"
      >
        <DialogHeader>
          <div className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#D4A373] font-body mb-2">
            Get in Touch
          </div>
          <DialogTitle className="font-display text-3xl sm:text-4xl tracking-tight leading-tight text-left">
            Contact Us
          </DialogTitle>
        </DialogHeader>

        <div className="mt-4 space-y-6">
          <p className="font-body text-sm sm:text-base leading-relaxed text-[#D4D4D8]">
            For support, refunds, press, screening enquiries or anything else —
            we&rsquo;d love to hear from you. Our team typically replies within
            24 hours.
          </p>

          <div className="border border-[#27272A] bg-[#0F0F0F] p-4 sm:p-5">
            <div className="text-[10px] tracking-[0.2em] uppercase text-[#A1A1AA] font-body mb-3 flex items-center gap-2">
              <Mail className="w-3.5 h-3.5 text-[#D4A373]" /> Email
            </div>
            <div className="flex items-center justify-between gap-3">
              <a
                href={`mailto:${SUPPORT_EMAIL}`}
                data-testid="contact-email-link"
                className="font-body text-base sm:text-lg text-[#F3F3F2] hover:text-[#D4A373] transition-colors break-all"
              >
                {SUPPORT_EMAIL}
              </a>
              <button
                data-testid="contact-copy-btn"
                onClick={copyEmail}
                className="shrink-0 inline-flex items-center gap-2 px-3 py-2 border border-[#27272A] hover:border-[#D4A373] text-[#A1A1AA] hover:text-[#D4A373] text-[10px] tracking-[0.2em] uppercase transition-colors"
              >
                {copied ? (
                  <>
                    <Check className="w-3.5 h-3.5" /> Copied
                  </>
                ) : (
                  <>
                    <Copy className="w-3.5 h-3.5" /> Copy
                  </>
                )}
              </button>
            </div>
          </div>

          <a
            href={`mailto:${SUPPORT_EMAIL}?subject=Byo%20Cha%20Khape%20%E2%80%94%20Enquiry`}
            data-testid="contact-mailto-btn"
            className="w-full inline-flex items-center justify-center gap-3 px-6 py-4 bg-[#D4A373] text-[#0A0A0A] hover:bg-[#E5B98D] transition-colors text-xs sm:text-sm tracking-[0.2em] uppercase font-semibold"
          >
            <Mail className="w-4 h-4" /> Open Email App
          </a>

          <div className="pt-4 border-t border-[#27272A] text-[10px] sm:text-xs tracking-[0.2em] uppercase text-[#52525B] font-body flex items-center justify-between">
            <span>A Sindhionism Original</span>
            <a
              href="https://instagram.com/byo_cha_khape"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 hover:text-[#D4A373] transition-colors"
            >
              <Instagram className="w-3.5 h-3.5" /> @byo_cha_khape
            </a>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
